import React, { useState, useEffect } from 'react';
import AdminOverview from './AdminOverview';
import AdminUsersList from './AdminUsersList';
import AdminUserDetail from './AdminUserDetail';

const AdminDashboard = ({ currentUser }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Check if user is admin
  useEffect(() => {
    if (!currentUser || (currentUser.role !== 'admin' && currentUser.email !== 'aayazali@gmail.com')) {
      console.warn('Non-admin user trying to access admin dashboard');
    }
  }, [currentUser]);

  if (!currentUser) return null;
  
  // If not admin, show access denied
  if (currentUser.role !== 'admin' && currentUser.email !== 'aayazali@gmail.com') {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-red-500 mb-4">Access Denied</h1>
          <p className="text-gray-400">You do not have permission to access the admin dashboard.</p>
        </div>
      </div>
    );
  }

  const handleViewUser = (userId) => {
    setSelectedUserId(userId);
    setActiveTab('user-detail');
  };

  const handleBackToUsers = () => {
    setSelectedUserId(null);
    setActiveTab('users');
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <div className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-orange-500">Admin Dashboard</h1>
              <p className="text-gray-400 text-sm mt-1">Manage users, subscriptions, and platform analytics</p>
            </div>
            <div className="text-sm text-gray-400">
              Admin Panel
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex space-x-4">
            <button
              onClick={() => setActiveTab('overview')}
              className={`px-4 py-3 font-medium border-b-2 transition-colors ${
                activeTab === 'overview'
                  ? 'border-orange-500 text-orange-500'
                  : 'border-transparent text-gray-400 hover:text-white'
              }`}
            >
              📊 Overview
            </button>
            <button
              onClick={() => setActiveTab('users')}
              className={`px-4 py-3 font-medium border-b-2 transition-colors ${
                activeTab === 'users' || activeTab === 'user-detail'
                  ? 'border-orange-500 text-orange-500'
                  : 'border-transparent text-gray-400 hover:text-white'
              }`}
            >
              👥 Users
            </button>
            <button
              onClick={() => setActiveTab('analytics')}
              className={`px-4 py-3 font-medium border-b-2 transition-colors ${
                activeTab === 'analytics'
                  ? 'border-orange-500 text-orange-500'
                  : 'border-transparent text-gray-400 hover:text-white'
              }`}
            >
              📈 Analytics
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        {activeTab === 'overview' && <AdminOverview adminId={currentUser.id} />}
        {activeTab === 'users' && (
          <AdminUsersList
            adminId={currentUser.id}
            onViewUser={handleViewUser}
          />
        )}
        {activeTab === 'user-detail' && selectedUserId && (
          <AdminUserDetail
            adminId={currentUser.id}
            userId={selectedUserId}
            onBack={handleBackToUsers}
          />
        )}
        {activeTab === 'analytics' && (
          <div className="bg-gray-800 rounded-lg p-6 text-center">
            <p className="text-gray-400">📈 Advanced analytics coming soon in Phase 2</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
